import React from 'react';

function CardBlock({ subtitle, cards, image }) {
  return (
    <div className='mb-12 max-w-3xl mx-auto'>
      {image && (
        <div className='mb-4 rounded-2xl overflow-hidden shadow'>
          <img
            src={image}
            alt={subtitle || '이미지'}
            className='w-full h-40 object-cover'
          />
        </div>
      )}
      {subtitle && <h2 className='text-lg font-semibold mb-4'>{subtitle}</h2>}
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-6'>
        {cards?.map((card, idx) => (
          <a
            key={idx}
            href={card.link}
            target='_blank'
            rel='noopener noreferrer'
            className='rounded-3xl p-5 text-white shadow transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg relative overflow-hidden'
            style={{ backgroundColor: card.bgColor || '#3b82f6' }}
          >
            {/* 배경 이미지 (있을 경우) */}
            {card.bgImage && (
              <div 
                className='absolute inset-0 opacity-30'
                style={{
                  backgroundImage: `url(${card.bgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              />
            )}
            {/* 카드 내용 */}
            <div className='flex flex-col justify-between h-full text-left relative z-10'>
              <div>
                <h3 className='text-base font-bold mb-1'>{card.title}</h3>
                <p className='text-sm opacity-90'>{card.description}</p>
              </div>
              <div className='text-right text-2xl mt-4'>{card.emoji}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default CardBlock;
